package com.partejar.app.feature.agenda.data

import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.plus

enum class AgendaPatientDestination {
    GESTANTE,
    RELACIONAMENTO
}

data class AgendaEvent(
    val id: Long,
    val type: String,
    val title: String,
    val startsAt: String,
    val endsAt: String,
    val patientId: Long? = null,
    val patientName: String? = null,
    val patientDestination: AgendaPatientDestination? = null
)

data class AgendaPeriod(
    val startDate: String,
    val endDate: String
)

fun interface AgendaPeriodProvider {
    fun current(): AgendaPeriod
}

class SystemAgendaPeriodProvider : AgendaPeriodProvider {
    override fun current(): AgendaPeriod {
        val today = currentAgendaDateTime().date
        return AgendaPeriod(today.toString(), today.plus(30, DateTimeUnit.DAY).toString())
    }
}

internal expect fun currentAgendaDateTime(): LocalDateTime

internal fun AgendaEvent.startDateTime(): LocalDateTime? =
    runCatching { LocalDateTime.parse(startsAt) }.getOrNull()

internal fun AgendaEvent.endDateTime(): LocalDateTime? =
    runCatching { LocalDateTime.parse(endsAt) }.getOrNull()

internal fun AgendaEvent.startDate(): LocalDate? = startDateTime()?.date

internal fun AgendaEvent.startsAtEpochMillis(): Long? =
    startDateTime()?.let(::agendaEpochMillis)

internal fun AgendaEvent.endsAtEpochMillis(): Long? =
    endDateTime()?.let(::agendaEpochMillis)

internal expect fun agendaEpochMillis(dateTime: LocalDateTime): Long

interface AgendaDataSource {
    suspend fun list(period: AgendaPeriod): List<AgendaEvent>
}
